<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">3. Suivi de saisie des clefs de scellement</p>
            <p class="no-margin dark-gray text-sm">Suivez la saisie des clefs par chaque membre du bureau.</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

  </div>


  <div *ngIf="isExpanded" id="information-grid" class="p-20">

    <div *ngFor="let assessor of assessors; let i = index"
      class="bg-pastel-blue p-10 mb-10 radius-10 flex content-between align-items-center">
      <ng-container *ngIf="{isValidated: isValidated || hasValidatedAssessorKey(assessor)} as status">
        <div>
          <p class="dark-blue bold no-margin">{{assessor.name}}</p>
          <p class="light-blue text-sm no-margin">{{assessor.email}}</p>
        </div>

        <div class="flex gap-10 align-items-center">
          <v8te-active-button *ngIf="!status.isValidated" [buttonText]="'Renvoyer email'"
            [boxShadow]="'0px 3px 6px #00000008'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
            [iconPosition]="'left'" [border]="'none'" [icon]="'assets/mail-dark-blue.svg'" [iconAlt]="'mail icon'"
            (click)="relaunchAssessorEvent.emit(assessor.email)" [height]="'40px'" [minWidth]="'180px'"
            [width]="'180px'"></v8te-active-button>
          <v8te-active-button *ngIf="!status.isValidated" [buttonText]="'Modifier email'"
            [boxShadow]="'0px 3px 6px #00000008'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
            [iconPosition]="'left'" [border]="'none'" [icon]="'assets/pen-icon.svg'" [iconAlt]="'pen icon'"
            (click)="updateAssessorEvent.emit(assessor.email)" [height]="'40px'" [minWidth]="'180px'"
            [width]="'180px'"></v8te-active-button>
          <app-custom-tag [isValidated]="true" [text]="status.isValidated ? 'Validée' : 'En attente'"
            [backgroundColor]="status.isValidated ? '#D2F8DD' : '#FFFBEC'"
            [textColor]="status.isValidated ? '#14532D' : '#F56D24'"
            [icon]="status.isValidated ? 'assets/valid-green-icon.svg' : 'assets/clock-orange-icon.svg'"></app-custom-tag>
        </div>
      </ng-container>
    </div>

    <div class="p-10 mb-10 radius-10" *ngIf="!isValidated"
      style="display: grid; grid-template-columns: auto 1fr auto; gap: 20px; align-items: center;">
      <p class="dark-blue bold no-margin" style="width: fit-content;">Clefs validées</p>
      <!-- <p>{{(assessors.length - remainingAssessors) / assessors.length * 100 | number:'1.0-1'}}%</p> -->
      <progress max="100" value="{{(assessors.length - remainingAssessors) / assessors.length * 100 | number:'1.0-1'}}"
        style="width: 100%;"></progress>
      <p class="dark-blue bold no-margin" style="width: fit-content;">{{assessors.length -
        remainingAssessors}}/{{assessors.length}}</p>
    </div>

    <div class="p-10 mb-10 radius-10" *ngIf="isValidated"
      style="display: grid; grid-template-columns: auto 1fr auto; gap: 20px; align-items: center;">
      <p class="dark-blue bold no-margin" style="width: fit-content;">Clefs validées</p>
      <!-- <p>{{(assessors.length - remainingAssessors) / assessors.length * 100 | number:'1.0-1'}}%</p> -->
      <progress max="100" value="100" style="width: 100%;"></progress>
      <p class="dark-blue bold no-margin" style="width: fit-content;">{{assessors.length -
        remainingAssessors}}/{{assessors.length}}</p>
    </div>

  </div>
</div>